import { styled } from '@mui/material/styles';
import { CircledIconProps } from './index';

export enum CircleSize {
  extraSmall = 'extraSmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export const paddingValues = {
  [CircleSize.extraSmall]:
    'var(--payment-component-circled-icon-padding-extra-small)',
  [CircleSize.small]: 'var(--payment-component-circled-icon-padding-small)',
  [CircleSize.medium]: 'var(--payment-component-circled-icon-padding-medium)',
  [CircleSize.large]: 'var(--payment-component-circled-icon-padding-large)',
};

export const StyledCircle = styled('div', {
  shouldForwardProp: (prop: string) =>
    !['backgroundRGBColor', 'opacity', 'color', 'size'].includes(prop),
})<CircledIconProps>((props) => {
  const { backgroundRGBColor, opacity, size, color } = props;

  return {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    color: color,
    backgroundColor: `rgba(${backgroundRGBColor}, ${opacity})`,
    ...(size && {
      padding: paddingValues[size],
    }),
  };
});
